import {useContext} from 'react';
import {useParams} from 'react-router-dom';
import {UserPlaylists} from '../../../../../../../components/user-playlists/user-playlists';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {ScreenPaths} from '../../../../../../../enums/screen-path';

export default function CaregiverPlaylistsSystemAdministratorOfficeScreen() {
  // Get context
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // Get params
  let {id}: {id?: string} = useParams();

  return (
    <UserPlaylists
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite
      userId={id || ''}
      userName={officeContext.state.userForm?.user.name || ''}
      playlistRowBaseLinkUrl={`${ScreenPaths.Office}${ScreenPaths.Office_SystemAdministrator}${ScreenPaths.SystemAdministrator_Playlists}`}
    />
  );
}
